import React from "react";
import maintenanceI from '../../images/home/maintenance.png';

function SoftwareMaintenance() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={maintenanceI}
                alt="Software Maintenance"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Keep Your Software Reliable And Up To Date</h2>

                <p>
                  Software needs ongoing attention after it has been
                  delivered. We provide maintenance and support to help
                  applications continue to perform effectively.
                </p>

                <p>
                  From bug fixes and updates to improvements and new
                  requirements, we can support your software as your business
                  evolves.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-features-section">
        <div className="container">
          <div className="section-heading text-center">

            <h2>Software Maintenance Services</h2>
          </div>

          <div className="row g-4">
            {[
              ["Bug Fixing", "Identify and resolve software issues that affect your application."],
              ["Updates", "Keep applications updated as requirements and technologies change."],
              ["Improvements", "Add improvements and enhancements based on new business requirements."]
            ].map(([title, text]) => (
              <div className="col-lg-4 col-md-6" key={title}>
                <div className="service-feature-card">
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">

          <h1>Software Maintenance</h1>
          <p style={{ color: '#FF7D37' }}>
            Ongoing technical support, improvements, updates, and maintenance
            for your software.
          </p>
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>SOFTWARE SUPPORT</span>
            <h2>Need Support For Existing Software?</h2>
            <p>Let's discuss your maintenance and support requirements.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default SoftwareMaintenance;